import React from 'react';
import VoiceRecorder from './VoiceRecorder';

function NarrativeBuilder({ caseData, setCaseData }) {
  function handleVoiceTranscript(text) {
    setCaseData(prev => ({
      ...prev,
      narrative: prev.narrative ? prev.narrative + '\n\n' + text : text,
    }));
  }

  return (
    <div className="ff-card" data-testid="narrative-builder">
      <h2>Your Narrative</h2>
      <p className="ff-card-description">
        Describe what happened in your own words. Focus on what you saw, heard, did, and were told.
      </p>

      <div className="ff-best-practice">
        <div className="ff-bp-title">Best practice</div>
        <ul>
          <li>Stick to observable facts</li>
          <li>Avoid guesses and assumptions</li>
          <li>Include exact words if they matter</li>
          <li>Keep sequence of events as clear as possible</li>
        </ul>
      </div>

      <textarea
        className="ff-textarea"
        value={caseData.narrative}
        onChange={(e) => setCaseData(prev => ({ ...prev, narrative: e.target.value }))}
        placeholder="Example: At about 7:35 AM, I raised a concern about the lockout status before we proceeded..."
        rows={10}
        data-testid="narrative-textarea"
      />

      <div className="ff-narrative-footer">
        <VoiceRecorder onTranscript={handleVoiceTranscript} />
        <div className="ff-char-count">
          {caseData.narrative.length} characters
        </div>
      </div>
    </div>
  );
}

export default NarrativeBuilder;
